@if (isNeosysAdmin()) {
  <div class="lp-impersonation-selector">
    @if (isImpersonating()) {
      <div class="dm-border-dashed dm-border-radius-8 dm-color-border-orange-200 dm-padding-8">
        <div class="dm-margin-bottom-4">
          <small i18n="@@impersonation.activePrefix">
            Angemeldet als:<br />
            <b>{{ impersonatedKundeName() }}</b>
          </small>
        </div>
        <dm-button dmType="button" color="secondary" size="sm" (click)="stopImpersonation()">
          <span i18n="@@impersonation.stop">Impersonation beenden</span>
        </dm-button>
      </div>
    } @else {
      <dm-combobox
        [showSearch]="true"
        [showSearchIcon]="true"
        [dynamicSearch]="true"
        [loading]="loading()"
        [filterDebounce]="300"
        placeholder="Kunde suchen…"
        i18n-placeholder="@@impersonation.searchPlaceholder"
        label="Als Kunde anmelden"
        i18n-label="@@impersonation.label"
        loadingLabel="Suche läuft…"
        i18n-loadingLabel="@@impersonation.loading"
        emptyStateTitle="Keine Kunden gefunden"
        i18n-emptyStateTitle="@@impersonation.emptyTitle"
        emptyStateDescription="Bitte einen anderen Suchbegriff versuchen."
        i18n-emptyStateDescription="@@impersonation.emptyDescription"
        (dmInput)="searchKunden($event.detail)"
        (dmChange)="startImpersonation($event.detail.value)"
      >
        @for (kunde of kunden(); track kunde.intId) {
          <dm-select-item [value]="kunde.intId!.toString()">{{ kunde.label }}</dm-select-item>
        }
      </dm-combobox>
    }
  </div>
}
